class KlaviyoBis extends HTMLElement {
  constructor() {
    super();

    this.initialise();
  }

  initialise() {
    this.querySelector('[data-open-bis]').addEventListener(
      'click',
      this.onOpenBisClick.bind(this)
    );
  }

  async onOpenBisClick(e) {
    e.preventDefault();

    this.popup = new window.Popup();

    const html = await window.fetchSection(
      `/products/${this.dataset.productHandle}?section_id=product-notifyme`
    ).then((section) => section.innerHTML);

    this.popup.insertContent(html);

    this.popup.el.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit(e) {
    if (!e.target.matches('[data-shopify-cart-notify-form]')) return;

    e.preventDefault();

    e.target.querySelector('button[type="submit"]').innerHTML = `
      <svg class="w-5 h-5 text-black animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g fill="currentColor"><g><path d="M24 47a23 23 0 1 1 23-23 23.025 23.025 0 0 1-23 23zm0-42a19 19 0 1 0 19 19A19.021 19.021 0 0 0 24 5z" opacity=".4"></path><path d="M47 24h-4A19.021 19.021 0 0 0 24 5V1a23.025 23.025 0 0 1 23 23z"></path></g></g>
      </svg>
    `;

    this.createNotification(e.target);
  }

  createNotification(form) {
    const formData = new FormData(form);
    const theID = this.dataset.klaviyoKey;
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${theID}`;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: formData.get('email')
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${formData.get('variant_id')}`
              }
            }
          }
        }
      })
    };

    fetch(url, options)
      .then((response) => {
        if (response.status !== 202) {
          throw new Error('Failed to subscribe');
        }

        this.popup.replaceContent(`
          <div class="p-6">
            <p>You're in! We'll let you know when it's back.</p>
          </div>
        `);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.popup.replaceContent(`
          <div class="p-6">
            <h3 class="mb-2 text-[28px]">Error</h3>
            <p class="mb-2 text-sm md:text-base">Unable to process your request. Please try again.</p>
            <button type="button" class="btn-black" data-popup-close>Close</button>
          </div>
        `);
      });
  }
}

if (!customElements.get('klaviyo-bis', KlaviyoBis)) {
  customElements.define('klaviyo-bis', KlaviyoBis);
}
